import { Injectable } from '@angular/core';
import { Platform } from '../platform/index';
var LyOverlayContainer = /** @class */ (function () {
    function LyOverlayContainer() {
        if (Platform.isBrowser) {
            var container = document.createElement('ly-overlay-container');
            document.body.appendChild(container);
            this._containerElement = container;
        }
    }
    Object.defineProperty(LyOverlayContainer.prototype, "containerElement", {
        get: function () {
            return this._containerElement;
        },
        enumerable: true,
        configurable: true
    });
    LyOverlayContainer.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LyOverlayContainer.ctorParameters = function () { return []; };
    return LyOverlayContainer;
}());
export { LyOverlayContainer };
//# sourceMappingURL=overlay-container.component.js.map